import { Table } from 'rsuite';

const { Column, HeaderCell, Cell } = Table;

interface RowNumberColumnProps {
  /** current page number (1-based) */
  page?: number;
  /** items per page */
  perPage?: number;
}

/**
 * Render a row number column for tables
 * Returns Column JSX directly (not a component wrapper) for rsuite-table compatibility
 * @param props
 */
export function renderRowNumberColumn({
  page = 1,
  perPage = 0,
}: RowNumberColumnProps = {}) {
  const offset = perPage > 0 ? (page - 1) * perPage : 0;

  return (
    <Column width={50} align="center" fixed>
      <HeaderCell className="table-column-number">#</HeaderCell>
      <Cell>
        {(rowData: any, rowIndex?: number) => offset + (rowIndex ?? 0) + 1}
      </Cell>
    </Column>
  );
}
